import { useState } from "react";

function useAsyncState(initialValue) {
  const [state, setState] = useState(initialValue);

  const setAsyncState = (value) =>
    new Promise((resolve) => {
      setState((prevState) => {
        const newValue = typeof value === "function" ? value(prevState) : value;
        resolve(newValue);
        return newValue;
      });
    });

  return [state, setAsyncState];
}

export default useAsyncState;
